import type { ActivityDefinition } from "@/lib/activities";

export type Step = "select-activity" | "event-details";

export type ActivityPickerFilter = "popular" | "matches" | "sessions" | "all";

export type ActivityPickerItem = {
  activity: ActivityDefinition;
  category: "matches" | "sessions";
  subtitle: string;
  searchText: string;
  isPopular: boolean;
  isRecent: boolean;
};

export const RECENT_SESSION_ACTIVITY_STORAGE_KEY =
  "hiive.recent-session-activities";
export const MAX_RECENT_SESSION_ACTIVITIES = 6;

export const QUICK_PICK_ACTIVITY_IDS = [
  "tennis",
  "football",
  "padel",
  "pickleball",
  "running",
  "hyrox",
  "recovery",
  "yoga",
] as const;

export const ACTIVITY_PICKER_FILTER_OPTIONS: Array<{
  value: ActivityPickerFilter;
  label: string;
}> = [
  { value: "popular", label: "Popular" },
  { value: "matches", label: "Matches" },
  { value: "sessions", label: "Social" },
  { value: "all", label: "All" },
];

export const SKILL_LEVEL_MIN = 1;
export const SKILL_LEVEL_MAX = 7;
